module.exports = __webpack_public_path__ + "assets/80d7e75ecbfb67193406a4554b51e312.png";